<template>
  <v-container fluid>

    <!-- 查询筛选区：姓名/手机号模糊查 + 司机属性/状态下拉精确查 -->
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-text-field v-model="queryForm.name" label="姓名" outlined dense clearable hide-details
          @keyup.enter="getdata()" />
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-text-field v-model="queryForm.mobile" label="手机号" outlined dense clearable hide-details
          @keyup.enter="getdata()" />
      </v-col>
      <!-- <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-select v-model="queryForm.own_type" :items="own_types" item-text="label" item-value="value" label="司机属性"
          no-data-text="无" outlined dense clearable hide-details :menu-props="{ bottom: true, offsetY: true }"
          @change="getdata()" />
      </v-col> -->
      <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-select v-model="queryForm.status" :items="statusOptions" item-text="label" item-value="value" label="状态"
          no-data-text="无" outlined dense clearable hide-details :menu-props="{ bottom: true, offsetY: true }"
          @change="getdata()" />
      </v-col>
      <v-col cols="12" xl="2" lg="3" md="3" sm="6">
        <!-- 操作按钮：查询/新增/导入/导出 -->
        <a-space>
          <v-btn color="primary" tile style="color:#fff;" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd">
            <v-icon small>mdi-plus</v-icon> 新增司机
          </v-btn>
          <v-btn color="cyan" dark tile @click="() => $refs.uploadRef.showupload()">
            <v-icon small>mdi-upload</v-icon> 导入司机
          </v-btn>
          <v-btn color="purple" dark tile @click="getdata('download')">
            <v-icon small>mdi-download</v-icon> 导出司机
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <!-- 快捷筛选 tab：全部/自有/包车/临调 -->
    <v-tabs v-model="own_type_tab" dense background-color="transparent" color="primary" class="mb-2"
      @change="onOwnTypeTabChange">
      <v-tab v-for="t in own_type_tabs" :key="t.label">{{ t.label }}</v-tab>
    </v-tabs>
    <!-- 司机列表表格 -->
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="limit" no-data-text="无数据"
        hide-default-footer disable-sort fixed-header :height="height">
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.create_time="{ item }">
          {{ item.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template v-slot:item.duration="{ item }">
          <!-- 在职周期：开始(绿)在上、结束(红)在下两行显示 -->
          <p v-if="item.start_day" class="success--text">{{ item.start_day }}</p>
          <p v-if="item.end_day" class="error--text">{{ item.end_day }}</p>
        </template>
        <template v-slot:item.own_type="{ item }">
          {{ own_type_text(item.own_type) }}
        </template>
        <template v-slot:item.status="{ item }">
          {{ status_text(item.status) }}
        </template>
        <template v-slot:item.leave_duration="{ item }">
          <!-- 请假周期：开始(绿)在上、结束(红)在下两行显示，与在职周期一致 -->
          <p v-if="item.leave_start_day" class="success--text">{{ item.leave_start_day }}</p>
          <p v-if="item.leave_end_day" class="error--text">{{ item.leave_end_day }}</p>
          <p v-if="!item.leave_start_day && !item.leave_end_day">--</p>
        </template>
        <template v-slot:item.action="{ item }">
          <a-space>
            <v-btn v-if="item.editable" text tile small color="success" @click="showedit(item)"> 编辑 </v-btn>
            <a-popconfirm v-if="item.removeable" title="删除司机" ok-text="确定" cancel-text="取消" @confirm="remove(item._id)">
              <v-btn text tile small color="error"> 删除 </v-btn>
            </a-popconfirm>
            <span v-if="item.blocked" class="error--text">已拉黑</span>
            <a-popconfirm v-else-if="item.blockable" title="拉黑司机" ok-text="确定" cancel-text="取消"
              @confirm="block(item._id)">
              <v-btn text tile small color="error"> 拉黑 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </v-data-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <!-- 新增/编辑司机弹窗 -->
    <v-dialog v-model="model" persistent max-width="650px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.name" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      姓名 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.mobile" :rules="[vrules.required]" dense outlined>
                    <template v-slot:label>
                      手机号 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.password" dense outlined>
                    <template v-slot:label>
                      密码
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="form.driver_license_type" dense outlined>
                    <template v-slot:label>
                      驾照类型
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
                    :return-value.sync="form.start_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.start_day" label="在职开始" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.start_day_menu.save(form.start_day); start_day_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
                    :return-value.sync="form.end_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.end_day" label="在职结束" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.end_day_menu.save(form.end_day); end_day_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="form.own_type" :items="own_types" item-text="label" item-value="value" label="司机属性"
                    no-data-text="无" dense outlined :menu-props="{ bottom: true, offsetY: true }">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select v-model="form.status" :items="statusOptions" item-text="label" item-value="value" label="状态"
                    no-data-text="无" dense outlined :menu-props="{ bottom: true, offsetY: true }">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu ref="leave_start_day_menu" v-model="leave_start_day_menu" :close-on-content-click="false"
                    :return-value.sync="form.leave_start_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.leave_start_day" label="请假开始" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.leave_start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.leave_start_day_menu.save(form.leave_start_day); leave_start_day_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu ref="leave_end_day_menu" v-model="leave_end_day_menu" :close-on-content-click="false"
                    :return-value.sync="form.leave_end_day" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.leave_end_day" label="请假结束" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined clearable>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.leave_end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.leave_end_day_menu.save(form.leave_end_day); leave_end_day_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <UploadTask ref="uploadRef" modelTitle="导入司机"
      :alertText="`上传Excel文件需包含 <span class='error--text'>姓名</span>、<span class='error--text'>手机号</span>、<span class='error--text'>所属公司</span>、<span>在职开始</span>、<span>在职结束</span> 字段`"
      uploadType="vehicledriver" />
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "CarrierPartner",
  data() {
    return {
      // 查询条件：姓名/手机号模糊查，own_type/status 下拉精确查
      queryForm: { name: "", mobile: "", own_type: null, status: null },
      // 顶部快捷 tab：null=全部
      own_type_tab: 0,
      own_type_tabs: [
        { label: "全部", value: null },
        { label: "自有", value: 1 },
        { label: "包车", value: 3 },
        { label: "临调", value: 2 },
      ],
      valid: true,
      // 表格列定义
      headers: [
        { text: "序号", value: "index", width: 80, align: "center" },
        { text: "姓名", value: "name", width: 120, align: "center" },
        { text: "手机号", value: "mobile", width: 120, align: "center" },
        { text: "驾照类型", value: "driver_license_type", width: 120, align: "center" },//A2,B2
        { text: "司机属性", value: "own_type", width: 120, align: "center" },//自有、包车、临调
        { text: "在职周期", value: "duration", width: 120, align: "center" },
        { text: "状态", value: "status", width: 120, align: "center" },//在岗、请假、离职
        { text: "请假周期", value: "leave_duration", width: 120, align: "center" },
        { text: "创建时间", value: "create_time", width: 120, align: "center" },
        { text: "操作", value: "action", width: 150, align: "center" },
      ],
      page: 1,
      limit: 30,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      model: false, // 新增/编辑弹窗显隐
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      // 各日期选择器菜单显隐
      start_day_menu: false,
      end_day_menu: false,
      leave_start_day_menu: false,
      leave_end_day_menu: false,
      // 状态选项：1在岗 2请假 -1离职
      statusOptions: [
        { value: 1, label: "在岗" },
        { value: 2, label: "请假" },
        { value: -1, label: "离职" },
      ],
      // 司机属性选项：1自有 3包车 2临调
      own_types: [
        { value: 1, label: "自有" },
        { value: 3, label: "包车" },
        { value: 2, label: "临调" },
      ],
      // 表单初始模板
      form_template: {
        _id: "",
        name: "",
        mobile: "",
        password: "",
        driver_license_type: "",
        status: 1,
        leave_start_day: "",
        leave_end_day: "",
        own_type: null,
        start_day: "",
        end_day: "",
      },
      form: {},
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    // 表格总宽度（所有列宽累加）
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    // 表格高度随窗口自适应
    this.height = window.innerHeight - 200;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 200;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    // tab 切换：同步到 queryForm.own_type 并刷新
    onOwnTypeTabChange(idx) {
      this.queryForm.own_type = this.own_type_tabs[idx].value;
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
    // 司机属性值转中文：1=自有 3=包车 2=临调
    own_type_text(v) {
      const m = { 1: "自有", 2: "临调", 3: "包车" };
      return m[v] || "--";
    },
    // 状态值转中文：1=在岗 2=请假 -1=离职
    status_text(v) {
      const m = { 1: "在岗", 2: "请假", "-1": "离职" };
      return m[v] || "--";
    },
    // 拉取司机列表；action='download' 时触发导出
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicledriver/list", { page: this.page, limit: this.limit, ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download') {
            return this.$download(res.data.url, res.data.name);
          }
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    // 打开新增弹窗：用模板重置表单
    showadd() {
      this.form = _.extend({}, { ...this.form_template });
      this.modeltitle = "新增司机";
      this.model = true;
    },
    // 打开编辑弹窗：按模板字段从行数据 pick 回填
    showedit(item) {
      this.form = _.pick(item, _.keys(this.form_template));
      this.modeltitle = "编辑司机";
      this.model = true;
    },
    // 保存（新增/编辑共用）：校验通过后提交
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicledriver/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    // 关闭弹窗并重置校验状态
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    // 删除司机
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicledriver/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    // 拉黑司机
    block(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/vehicledriver/block", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-text-field__details {
  margin-bottom: 0 !important;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
